/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from "@react-navigation/native";
import * as Linking from "expo-linking";

import { RootStackParamList } from "../types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.makeUrl("/")],
  config: {
    screens: {
      Root: {
        screens: {
          Lobby: {
            screens: {
              LobbyScreen: "lobby",
            },
          },
          Cash: {
            screens: {
              LobbyScreen: "cash",
            },
          },
          Tournament: {
            screens: {
              TournamentScreen: "tournament",
            },
          },
          Rakeback: {
            screens: {
              RakeBackScreen: "rakeback",
            },
          },
          Profile: {
            screens: {
              ProfileScreen: "profile",
            },
          },
        },
      },
      Table: "table",
      Cashier: "cashier",
      Modal: "modal",
      Maintenance: "maintenance",
      PlayBonds: "playbonds",
      NotFound: "*",
    },
  },
};

export default linking;
